// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__Row--iKbTD{height:71px;transition:all .25s ease;transition-property:background-color,box-shadow}a{color:#cf4800;text-decoration:underline}a:hover{color:#cf4800}a:active{color:#e55a00}a--secondary{color:#5c626e;text-decoration:none}a--secondary:hover{color:#414752;text-decoration:underline}.index-module__Wrapper--vZBrx{color:#414752;font-size:20px;display:flex;justify-content:center;align-items:center;grid-area:content;height:100vh}.index-module__Wrapper--vZBrx .index-module__Content--ZB20L{flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/stylesheets/base/_uiLibStyles.module.scss","webpack://./src/components/LoadingContent/index.module.scss"],"names":[],"mappings":"AAqSA,0BACE,WAvBiB,CAwBjB,wBAAA,CACA,+CAAA,CAGF,EACE,aAzOiB,CA0OjB,yBAAA,CAEA,QACE,aA7Oe,CAgPjB,SACE,aAhPiB,CAkPnB,aACE,aA9OO,CA+OP,oBAAA,CACA,mBACE,aAlPK,CAmPL,yBAAA,CCzTN,8BACE,aDqES,CCpET,cDcG,CCbH,YAAA,CACA,sBAAA,CACA,kBAAA,CACA,iBAAA,CACA,YAAA,CAEA,4DACE,qBAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');\n\n$font-primary: 'Lato', sans-serif;\n$font-weight-heavy: 700;\n\n/* Design System Jan 2020 */\n\n$body-baseline: 16px;\n$intro-text: 18px;\n$micro: 12px;\n$caption: 14px;\n$giant: 48px;\n$h1: 32px;\n$h1-tablet: 28px;\n$h2: 28px;\n$h2-tablet: 24px;\n$h3: 24px;\n$h3-tablet: 20px;\n$h4: 20px;\n\n/* stylelint-enable */\n// spacing\n$spacing-nano: 2px;\n$spacing-micro: 4px;\n$spacing-tiny: 8px;\n$spacing-smallest: 12px;\n$spacing-small: 16px;\n$spacing-standard: 24px;\n$spacing-semi: 32px;\n$spacing-large: 48px;\n$spacing-xlarge: 64px;\n\n//sizes\n$border-radius: 4px;\n$border-radius-large: 8px;\n\n$widget-height: 30vh;\n$widget-width: 100%;\n\n$context-bar-height: 62px;\n$context-bar-width: 100%;\n\n$ecosystem-header-height: 78px;\n$ecosystem-footer-height: 76px;\n\n$desktop-width: 1366px;\n$desktop-width-medium: 1440px;\n$desktop-width-large: 1680px;\n$desktop-width-extra-large: 1920px;\n$tablet-portrait-width: 768px;\n\n$media-desktop: 'only screen and (min-width: #{$desktop-width})';\n$media-desktop-medium: 'only screen and (min-width: #{$desktop-width-medium})';\n$media-desktop-large: 'only screen and (min-width: #{$desktop-width-large})';\n$media-desktop-extra-large: 'only screen and (min-width: #{$desktop-width-extra-large})';\n\n// animations\n/* Transitions */\n$transition-time-default: 0.25s;\n$transition-time-short: 0.1s;\n\n$transition-default: $transition-time-default ease;\n\n/* stylelint-disable color-no-hex */\n\n/* new pallete from march 2021*/\n/* ui colors */\n$brand-darkorange: #cf4800;\n$brand-brightorange: #e55a00;\n$brand-lightorange: #fdefe6;\n$brand-superlightorange: #fdf6f2;\n$grey-900: #323842;\n$grey-800: #414752;\n$grey-700: #5c626e;\n$grey-600: #6f7582;\n$grey-500: #9499a3;\n$grey-400: #bbc0c9;\n$grey-300: #dadde3;\n$grey-200: #ebecf0;\n$grey-100: #f5f6f7;\n$ui-white: #fff;\n$ui-green: #167922;\n$ui-red: #bc1c0e;\n\n/* data vis colours */\n$blue-800: #2b4c9b;\n$blue-700: #3456a6;\n$blue-600: #3c60b3;\n$blue-500: #4368bd;\n$blue-400: #6480c3;\n$blue-300: #879bcc;\n$blue-200: #afbbdb;\n$blue-100: #dbe0eb;\n$petrol-800: #428a81;\n$petrol-700: #4b9a91;\n$petrol-600: #4da9a1;\n$petrol-500: #54b9b1;\n$petrol-400: #63c8c2;\n$petrol-300: #81d7d3;\n$petrol-200: #b2edeb;\n$petrol-100: #e2ffff;\n$magenta-800: #97254f;\n$magenta-700: #ac2b55;\n$magenta-600: #c02d58;\n$magenta-500: #d2335f;\n$magenta-400: #d44a73;\n$magenta-300: #d76789;\n$magenta-200: #da91a7;\n$magenta-100: #ddbbc5;\n$yellow-800: #ee7c24;\n$yellow-700: #f58a27;\n$yellow-600: #fa9a2a;\n$yellow-500: #ffa52f;\n$yellow-400: #fdb244;\n$yellow-300: #fdc166;\n$yellow-200: #fed79a;\n$yellow-100: #ffebcc;\n$purple-800: #5c399b;\n$purple-700: #673fa2;\n$purple-600: #7249ad;\n$purple-500: #7b4db3;\n$purple-400: #8d69bb;\n$purple-300: #a387c8;\n$purple-200: #bfb0d4;\n$purple-100: #ddd8e4;\n$ext-grey-100: #d6d9dc;\n$ext-grey-200: #c0c5c8;\n$ext-grey-300: #9fa7ad;\n$ext-grey-400: #7f888e;\n$ext-grey-500: #6a757c;\n$ext-grey-600: #535d63;\n$ext-grey-700: #3b4145;\n$ext-grey-800: #171a1c;\n$red-100: #cba6a8;\n$red-200: #bb7471;\n$red-300: #b0504c;\n$red-400: #ba302a;\n$red-500: #bc1c0e;\n$red-600: #ad0e0e;\n$red-700: #9b0009;\n$red-800: #8f0001;\n$green-100: #bde5bd;\n$green-200: #98d299;\n$green-300: #73c375;\n$green-400: #59b75b;\n$green-500: #3dad42;\n$green-600: #329d38;\n$green-700: #24892c;\n$green-800: #167922;\n\n/* descriptive tokens */\n$text-heading: $grey-900;\n$text-default: $grey-800;\n$text-secondary-interactive: $grey-700;\n$text-lighter: $grey-600;\n$text-inactive: $grey-500;\n$stroke: $grey-400;\n$stroke-light: $grey-300;\n$background-darkest: $grey-600;\n$background-dark: $grey-300;\n$background-medium: $grey-200;\n$background-light: $grey-100;\n$color-focus: $yellow-200;\n\n/* end colours from design system */\n\n/* need to address these two */\n$modal-background: rgba(0, 10, 20, 0.5);\n$brand-brightorange-200: #ffd07c;\n\n/* stylelint-enable */\n\n$colors:\n  'brand-darkorange' $brand-darkorange,\n  'brand-brightorange' $brand-brightorange,\n  'brand-superlightorange' $brand-superlightorange,\n  'grey-800' $grey-800,\n  'grey-700' $grey-700,\n  'grey-600' $grey-600,\n  'grey-500' $grey-500,\n  'grey-400' $grey-400,\n  'grey-300' $grey-300,\n  'grey-200' $grey-200,\n  'grey-100' $grey-100,\n  'ext-grey-800' $ext-grey-800,\n  'ext-grey-700' $ext-grey-700,\n  'ext-grey-600' $ext-grey-600,\n  'ext-grey-500' $ext-grey-500,\n  'ext-grey-400' $grey-400,\n  'ext-grey-300' $ext-grey-300,\n  'ext-grey-200' $ext-grey-200,\n  'ext-grey-100' $grey-100,\n  'white' $ui-white,\n  'green' $ui-green,\n  'red' $ui-red,\n  'blue-800' $blue-800,\n  'blue-700' $blue-700,\n  'blue-600' $blue-600,\n  'blue-500' $blue-500,\n  'blue-400' $blue-400,\n  'blue-300' $blue-300,\n  'blue-200' $blue-200,\n  'blue-100' $blue-100,\n  'petrol-800' $petrol-800,\n  'petrol-700' $petrol-700,\n  'petrol-600' $petrol-600,\n  'petrol-500' $petrol-500,\n  'petrol-400' $petrol-400,\n  'petrol-300' $petrol-300,\n  'petrol-200' $petrol-200,\n  'petrol-100' $petrol-100,\n  'magenta-800' $magenta-800,\n  'magenta-700' $magenta-700,\n  'magenta-600' $magenta-600,\n  'magenta-500' $magenta-500,\n  'magenta-400' $magenta-400,\n  'magenta-300' $magenta-300,\n  'magenta-200' $magenta-200,\n  'magenta-100' $magenta-100,\n  'yellow-800' $yellow-800,\n  'yellow-700' $yellow-700,\n  'yellow-600' $yellow-600,\n  'yellow-500' $yellow-500,\n  'yellow-400' $yellow-400,\n  'yellow-300' $yellow-300,\n  'yellow-200' $yellow-200,\n  'yellow-100' $yellow-100,\n  'purple-800' $purple-800,\n  'purple-700' $purple-700,\n  'purple-600' $purple-600,\n  'purple-500' $purple-500,\n  'purple-400' $purple-400,\n  'purple-300' $purple-300,\n  'purple-200' $purple-200,\n  'purple-100' $purple-100,\n  'red-800' $red-800,\n  'red-700' $red-700,\n  'red-600' $red-600,\n  'red-500' $red-500,\n  'red-400' $red-400,\n  'red-300' $red-300,\n  'red-200' $red-200,\n  'red-100' $red-100,\n  'green-800' $green-800,\n  'green-700' $green-700,\n  'green-600' $green-600,\n  'green-500' $green-500,\n  'green-400' $green-400,\n  'green-300' $green-300,\n  'green-200' $green-200,\n  'green-100' $green-100,\n  'ui-green' $ui-green,\n  'ui-red' $ui-red,\n  'text-heading' $text-heading,\n  'text-default' $text-default,\n  'text-secondary-interactive' $text-secondary-interactive,\n  'text-lighter' $text-lighter,\n  'text-inactive' $text-inactive,\n  'stroke' $stroke,\n  'stroke-light' $stroke-light,\n  'background-darkest' $background-darkest,\n  'background-dark' $background-dark,\n  'background-medium' $background-medium,\n  'background-light' $background-light,\n  'color-focus' $color-focus;\n\n$shadow-sm: 0px 2px 2px 0px rgba(0, 0, 0, 0.1);\n$shadow-lg: 0px 4px 2px 0px rgba(0, 0, 0, 0.1);\n$shadow-focus: 0 0 1px 2px $color-focus;\n$shadow-inner: none;\n\n$table-row-height: 71px;\n$hover-color: $brand-superlightorange;\n\n$sort-cell-color: $background-light;\n$sort-hover-cell-color: $brand-lightorange;\n\n$z-index-negative: -1;\n$z-index-default: 1;\n$z-index-focus: 2;\n$z-index-sticky: 10;\n$z-index-chart-tooltip: 40;\n$z-index-dropdown: 50;\n$z-index-tooltip: 100;\n$z-index-modal-overlay: 8000;\n$z-index-modal: 9000;\n$z-index-toast: 10000;\n\n@mixin highlight {\n  background-color: $hover-color;\n  box-shadow: inset 3px 0px 0px $brand-brightorange;\n}\n\n.Row {\n  height: $table-row-height;\n  transition: all $transition-default;\n  transition-property: background-color, box-shadow;\n}\n\na {\n  color: $brand-darkorange;\n  text-decoration: underline;\n\n  &:hover {\n    color: $brand-darkorange;\n  }\n\n  &:active {\n    color: $brand-brightorange;\n  }\n  &--secondary {\n    color: $text-secondary-interactive;\n    text-decoration: none;\n    &:hover {\n      color: $text-default;\n      text-decoration: underline;\n    }\n  }\n}\n:export {\n  chartTooltip: $z-index-chart-tooltip;\n  focus: $z-index-focus;\n  shadow-sm: $shadow-sm;\n  shadow-lg: $shadow-lg;\n  shadow-focus: $shadow-focus;\n  font-primary: $font-primary;\n  micro: $micro;\n  caption: $caption;\n  brand-darkorange: $brand-darkorange;\n  brand-brightorange: $brand-brightorange;\n  brand-superlightorange: $brand-superlightorange;\n  grey-800: $grey-800;\n  grey-700: $grey-700;\n  grey-600: $grey-600;\n  grey-500: $grey-500;\n  grey-400: $grey-400;\n  grey-300: $grey-300;\n  grey-200: $grey-200;\n  grey-100: $grey-100;\n  white: $ui-white;\n  green: $ui-green;\n  red: $ui-red;\n  blue-800: $blue-800;\n  blue-700: $blue-700;\n  blue-600: $blue-600;\n  blue-500: $blue-500;\n  blue-400: $blue-400;\n  blue-300: $blue-300;\n  blue-200: $blue-200;\n  blue-100: $blue-100;\n  petrol-800: $petrol-800;\n  petrol-700: $petrol-700;\n  petrol-600: $petrol-600;\n  petrol-500: $petrol-500;\n  petrol-400: $petrol-400;\n  petrol-300: $petrol-300;\n  petrol-200: $petrol-200;\n  petrol-100: $petrol-100;\n  magenta-800: $magenta-800;\n  magenta-700: $magenta-700;\n  magenta-600: $magenta-600;\n  magenta-500: $magenta-500;\n  magenta-400: $magenta-400;\n  magenta-300: $magenta-300;\n  magenta-200: $magenta-200;\n  magenta-100: $magenta-100;\n  yellow-800: $yellow-800;\n  yellow-700: $yellow-700;\n  yellow-600: $yellow-600;\n  yellow-500: $yellow-500;\n  yellow-400: $yellow-400;\n  yellow-300: $yellow-300;\n  yellow-200: $yellow-200;\n  yellow-100: $yellow-100;\n  green-800: $green-800;\n  green-700: $green-700;\n  green-600: $green-600;\n  green-500: $green-500;\n  green-400: $green-400;\n  green-300: $green-300;\n  green-200: $green-200;\n  green-100: $green-100;\n  red-800: $red-800;\n  red-700: $red-700;\n  red-600: $red-600;\n  red-500: $red-500;\n  red-400: $red-400;\n  red-300: $red-300;\n  red-200: $red-200;\n  red-100: $red-100;\n  purple-800: $purple-800;\n  purple-700: $purple-700;\n  purple-600: $purple-600;\n  purple-500: $purple-500;\n  purple-400: $purple-400;\n  purple-300: $purple-300;\n  purple-200: $purple-200;\n  purple-100: $purple-100;\n  ext-grey-800: $ext-grey-800;\n  ext-grey-700: $ext-grey-700;\n  ext-grey-600: $ext-grey-600;\n  ext-grey-500: $ext-grey-500;\n  ext-grey-400: $ext-grey-400;\n  ext-grey-300: $ext-grey-300;\n  ext-grey-200: $ext-grey-200;\n  ext-grey-100: $ext-grey-100;\n  ui-green: $ui-green;\n  ui-red: $ui-red;\n  text-heading: $text-heading;\n  text-default: $text-default;\n  text-secondary-interactive: $text-secondary-interactive;\n  text-lighter: $text-lighter;\n  text-inactive: $text-inactive;\n  stroke: $stroke;\n  stroke-light: $stroke-light;\n  background-darkest: $background-darkest;\n  background-dark: $background-dark;\n  background-medium: $background-medium;\n  background-light: $background-light;\n  color-focus: $color-focus;\n  colors-0: $blue-500;\n  colors-1: $petrol-500;\n  colors-2: $yellow-500;\n  colors-3: $magenta-500;\n  colors-4: $purple-500;\n  colors-5: $blue-300;\n  colors-6: $purple-200;\n  colors-7: $magenta-800;\n  colors-8: $petrol-600;\n  colors-9: $yellow-100;\n  colors-10: $yellow-400;\n  colors-11: $purple-400;\n  colors-12: $blue-200;\n  colors-13: $magenta-200;\n  colors-14: $petrol-300;\n  colors-15: $magenta-400;\n  colors-16: $purple-800;\n  colors-17: $yellow-700;\n  colors-18: $purple-300;\n  colors-19: $petrol-800;\n  colors-20: $yellow-200;\n  colors-21: $blue-400;\n  colors-22: $magenta-100;\n  colors-23: $petrol-700;\n  colors-24: $purple-100;\n  colors-25: $magenta-600;\n  colors-26: $petrol-100;\n  colors-27: $yellow-300;\n  colors-28: $blue-100;\n  colors-29: $purple-700;\n}\n\n/* stylelint-enable */\n","@use '../../stylesheets/base/uiLibStyles.module' as *;\n\n.Wrapper {\n  color: $text-default;\n  font-size: $h4;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  grid-area: content;\n  height: 100vh;\n\n  .Content {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var chartTooltip = `40`;
export var focus = `2`;
var _1 = `0px 2px 2px 0px rgba(0,0,0,.1)`;
export { _1 as "shadow-sm" };
var _2 = `0px 4px 2px 0px rgba(0,0,0,.1)`;
export { _2 as "shadow-lg" };
var _3 = `0 0 1px 2px #fed79a`;
export { _3 as "shadow-focus" };
var _4 = `"Lato",sans-serif`;
export { _4 as "font-primary" };
export var micro = `12px`;
export var caption = `14px`;
var _5 = `#cf4800`;
export { _5 as "brand-darkorange" };
var _6 = `#e55a00`;
export { _6 as "brand-brightorange" };
var _7 = `#fdf6f2`;
export { _7 as "brand-superlightorange" };
var _8 = `#414752`;
export { _8 as "grey-800" };
var _9 = `#5c626e`;
export { _9 as "grey-700" };
var _a = `#6f7582`;
export { _a as "grey-600" };
var _b = `#9499a3`;
export { _b as "grey-500" };
var _c = `#bbc0c9`;
export { _c as "grey-400" };
var _d = `#dadde3`;
export { _d as "grey-300" };
var _e = `#ebecf0`;
export { _e as "grey-200" };
var _f = `#f5f6f7`;
export { _f as "grey-100" };
export var white = `#fff`;
export var green = `#167922`;
export var red = `#bc1c0e`;
var _10 = `#2b4c9b`;
export { _10 as "blue-800" };
var _11 = `#3456a6`;
export { _11 as "blue-700" };
var _12 = `#3c60b3`;
export { _12 as "blue-600" };
var _13 = `#4368bd`;
export { _13 as "blue-500" };
var _14 = `#6480c3`;
export { _14 as "blue-400" };
var _15 = `#879bcc`;
export { _15 as "blue-300" };
var _16 = `#afbbdb`;
export { _16 as "blue-200" };
var _17 = `#dbe0eb`;
export { _17 as "blue-100" };
var _18 = `#428a81`;
export { _18 as "petrol-800" };
var _19 = `#4b9a91`;
export { _19 as "petrol-700" };
var _1a = `#4da9a1`;
export { _1a as "petrol-600" };
var _1b = `#54b9b1`;
export { _1b as "petrol-500" };
var _1c = `#63c8c2`;
export { _1c as "petrol-400" };
var _1d = `#81d7d3`;
export { _1d as "petrol-300" };
var _1e = `#b2edeb`;
export { _1e as "petrol-200" };
var _1f = `#e2ffff`;
export { _1f as "petrol-100" };
var _20 = `#97254f`;
export { _20 as "magenta-800" };
var _21 = `#ac2b55`;
export { _21 as "magenta-700" };
var _22 = `#c02d58`;
export { _22 as "magenta-600" };
var _23 = `#d2335f`;
export { _23 as "magenta-500" };
var _24 = `#d44a73`;
export { _24 as "magenta-400" };
var _25 = `#d76789`;
export { _25 as "magenta-300" };
var _26 = `#da91a7`;
export { _26 as "magenta-200" };
var _27 = `#ddbbc5`;
export { _27 as "magenta-100" };
var _28 = `#ee7c24`;
export { _28 as "yellow-800" };
var _29 = `#f58a27`;
export { _29 as "yellow-700" };
var _2a = `#fa9a2a`;
export { _2a as "yellow-600" };
var _2b = `#ffa52f`;
export { _2b as "yellow-500" };
var _2c = `#fdb244`;
export { _2c as "yellow-400" };
var _2d = `#fdc166`;
export { _2d as "yellow-300" };
var _2e = `#fed79a`;
export { _2e as "yellow-200" };
var _2f = `#ffebcc`;
export { _2f as "yellow-100" };
var _30 = `#167922`;
export { _30 as "green-800" };
var _31 = `#24892c`;
export { _31 as "green-700" };
var _32 = `#329d38`;
export { _32 as "green-600" };
var _33 = `#3dad42`;
export { _33 as "green-500" };
var _34 = `#59b75b`;
export { _34 as "green-400" };
var _35 = `#73c375`;
export { _35 as "green-300" };
var _36 = `#98d299`;
export { _36 as "green-200" };
var _37 = `#bde5bd`;
export { _37 as "green-100" };
var _38 = `#8f0001`;
export { _38 as "red-800" };
var _39 = `#9b0009`;
export { _39 as "red-700" };
var _3a = `#ad0e0e`;
export { _3a as "red-600" };
var _3b = `#bc1c0e`;
export { _3b as "red-500" };
var _3c = `#ba302a`;
export { _3c as "red-400" };
var _3d = `#b0504c`;
export { _3d as "red-300" };
var _3e = `#bb7471`;
export { _3e as "red-200" };
var _3f = `#cba6a8`;
export { _3f as "red-100" };
var _40 = `#5c399b`;
export { _40 as "purple-800" };
var _41 = `#673fa2`;
export { _41 as "purple-700" };
var _42 = `#7249ad`;
export { _42 as "purple-600" };
var _43 = `#7b4db3`;
export { _43 as "purple-500" };
var _44 = `#8d69bb`;
export { _44 as "purple-400" };
var _45 = `#a387c8`;
export { _45 as "purple-300" };
var _46 = `#bfb0d4`;
export { _46 as "purple-200" };
var _47 = `#ddd8e4`;
export { _47 as "purple-100" };
var _48 = `#171a1c`;
export { _48 as "ext-grey-800" };
var _49 = `#3b4145`;
export { _49 as "ext-grey-700" };
var _4a = `#535d63`;
export { _4a as "ext-grey-600" };
var _4b = `#6a757c`;
export { _4b as "ext-grey-500" };
var _4c = `#7f888e`;
export { _4c as "ext-grey-400" };
var _4d = `#9fa7ad`;
export { _4d as "ext-grey-300" };
var _4e = `#c0c5c8`;
export { _4e as "ext-grey-200" };
var _4f = `#d6d9dc`;
export { _4f as "ext-grey-100" };
var _50 = `#167922`;
export { _50 as "ui-green" };
var _51 = `#bc1c0e`;
export { _51 as "ui-red" };
var _52 = `#323842`;
export { _52 as "text-heading" };
var _53 = `#414752`;
export { _53 as "text-default" };
var _54 = `#5c626e`;
export { _54 as "text-secondary-interactive" };
var _55 = `#6f7582`;
export { _55 as "text-lighter" };
var _56 = `#9499a3`;
export { _56 as "text-inactive" };
export var stroke = `#bbc0c9`;
var _57 = `#dadde3`;
export { _57 as "stroke-light" };
var _58 = `#6f7582`;
export { _58 as "background-darkest" };
var _59 = `#dadde3`;
export { _59 as "background-dark" };
var _5a = `#ebecf0`;
export { _5a as "background-medium" };
var _5b = `#f5f6f7`;
export { _5b as "background-light" };
var _5c = `#fed79a`;
export { _5c as "color-focus" };
var _5d = `#4368bd`;
export { _5d as "colors-0" };
var _5e = `#54b9b1`;
export { _5e as "colors-1" };
var _5f = `#ffa52f`;
export { _5f as "colors-2" };
var _60 = `#d2335f`;
export { _60 as "colors-3" };
var _61 = `#7b4db3`;
export { _61 as "colors-4" };
var _62 = `#879bcc`;
export { _62 as "colors-5" };
var _63 = `#bfb0d4`;
export { _63 as "colors-6" };
var _64 = `#97254f`;
export { _64 as "colors-7" };
var _65 = `#4da9a1`;
export { _65 as "colors-8" };
var _66 = `#ffebcc`;
export { _66 as "colors-9" };
var _67 = `#fdb244`;
export { _67 as "colors-10" };
var _68 = `#8d69bb`;
export { _68 as "colors-11" };
var _69 = `#afbbdb`;
export { _69 as "colors-12" };
var _6a = `#da91a7`;
export { _6a as "colors-13" };
var _6b = `#81d7d3`;
export { _6b as "colors-14" };
var _6c = `#d44a73`;
export { _6c as "colors-15" };
var _6d = `#5c399b`;
export { _6d as "colors-16" };
var _6e = `#f58a27`;
export { _6e as "colors-17" };
var _6f = `#a387c8`;
export { _6f as "colors-18" };
var _70 = `#428a81`;
export { _70 as "colors-19" };
var _71 = `#fed79a`;
export { _71 as "colors-20" };
var _72 = `#6480c3`;
export { _72 as "colors-21" };
var _73 = `#ddbbc5`;
export { _73 as "colors-22" };
var _74 = `#4b9a91`;
export { _74 as "colors-23" };
var _75 = `#ddd8e4`;
export { _75 as "colors-24" };
var _76 = `#c02d58`;
export { _76 as "colors-25" };
var _77 = `#e2ffff`;
export { _77 as "colors-26" };
var _78 = `#fdc166`;
export { _78 as "colors-27" };
var _79 = `#dbe0eb`;
export { _79 as "colors-28" };
var _7a = `#673fa2`;
export { _7a as "colors-29" };
export var Row = `index-module__Row--iKbTD`;
export var Wrapper = `index-module__Wrapper--vZBrx`;
export var Content = `index-module__Content--ZB20L`;
export default ___CSS_LOADER_EXPORT___;
